const REFERRAL_SIDEBAR_BADGE = '+3.5K SC';

export const getReferralSidebarMarker = (
  isAuthenticated: boolean,
  availableRewardsCount = 0,
): string | number => {
  if (!isAuthenticated) {
    return REFERRAL_SIDEBAR_BADGE;
  }

  return availableRewardsCount || REFERRAL_SIDEBAR_BADGE;
};
